export enum JournalEntryReportItemTemplateCategories {
    IncomeType = 'income types',
    Deductions = 'deductions',
    Benefits = 'benefits',
}
